import gql from 'graphql-tag'

const PRODUCT = gql`
  fragment RecommendedProduct on Product {
    id
    productErpIdentifier
    displayName
    englishFullDisplayName
    primaryImageId
    manufacturerName
    manufacturerProductIdentifier
    displaySpecifications
    oneLiner
    internalProduct
    nameSlug
    energyClass
    energyDocumentId
    energyLabelImageId
    reviewScore
    reviewCount
    isNewProduct
    showSpecificationsInProductCardTitle
    promotedSpecifications(take: 4) {
      name
      value
    }
    price {
      campaignPercentage
      campaignType
      formatted {
        price
        originalPrice
        priceExcludingVat
        priceIncludingVat
      }
      isBestSeller
      isBid
      isCampaign
      isRecommendedProduct
      price
      priceExcludingVat
      priceIncludingVat
      originalPrice
      priceVat
    }
    availability {
      IsNotifyEligible
      maxAvailableQuantity
      internalEtaStock {
        quantity
        eta
      }
      externalStock {
        leadTime
        quantity
      }
      availabilityDetails {
        formattedDateUtc
        key
      }
      availabilityStatus
      availabilityStatusPresentation
      internalStock {
        quantity
        showAlwaysInStock
      }
      isAvailableForSale
      isPreOrder
      productLifeCycleState
      showAvailabilityQuantities
      showEtaDate
    }
    minQuantityPerOrder
    category {
      englishPathSlug
      name
      namePath
    }
  }
`

export const GET_LANDING_PAGE = gql`
  ${PRODUCT}

  query GetLandingPage(
    $pageSize: Int!
    $page: Int!
    $searchPhrase: String
    $facets: [FacetParameterInput!]
    $sortBy: SortBy!
    $pageReference: String!
    $touchpoint: Touchpoint!
  ) {
    landingPage(
      pageSize: $pageSize
      page: $page
      searchPhrase: $searchPhrase
      facets: $facets
      sortBy: $sortBy
      pageReference: $pageReference
      touchpoint: $touchpoint
    ) {
      pageId
      recommendationList {
        algorithm
        id
        label
        limit
        showMoreLink
        visible
        visualization
        productReferences {
          productErpIdentifier
          ticket
          product {
            ...RecommendedProduct
          }
        }
      }
    }
  }
`
